"use client";

import type * as React from "react";
import { ReactComponent as LogoIcon } from "@/assets/logos/1007-cloud-sinus_1.svg";
import { Stack } from "@mui/material";

const HEIGHT = 60;
const WIDTH = 60;

export interface LogoProps {
	color?: string;
	emblem?: boolean;
	height?: number;
	width?: number;
}

export function CloudLogo({ color, height = HEIGHT, width = WIDTH }: LogoProps): React.JSX.Element {
	return (
		<Stack alignItems="center" sx={{ width: "100%", margin: "0 auto" }}>
			<LogoIcon
				style={{
					width: width,
					height: height,
					fill: color,
				}}
			/>
		</Stack>
	);
}
